(function() {
    'use strict';

    const CONFIG = {
        defaultPhone: '910-457-7333',
        trackingPhone: '910-363-0272',
        cookieExpireDays: 30,
        utmParams: [
            'utm_source',
            'utm_campaign',
            'utm_content',
            'utm_medium'
        ],
        gravityFormsMapping: {
            '1': {
                'utm_source': '9',
                'utm_medium': '10',
                'utm_campaign': '11',
                'utm_content': '12'
                
            },
            '2': {
                'utm_source': '9',
                'utm_medium': '10',
                'utm_campaign': '11',
                'utm_content': '12'
                
            },
            '3': {
                'utm_source': '9',
                'utm_medium': '10',
                'utm_campaign': '11',
                'utm_content': '12'
                
            },
            '7': {
                'utm_source': '9',
                'utm_medium': '10',
                'utm_campaign': '11',
                'utm_content': '12'
                
            },
            '8': {
                'utm_source': '9',
                'utm_medium': '10',
                'utm_campaign': '11',
                'utm_content': '12'
                
            },
            '9': {
                'utm_source': '9',
                'utm_medium': '10',
                'utm_campaign': '11',
                'utm_content': '12'
                
            }
        }
    };

    // Set a cookie with expiration
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + date.toUTCString();
        document.cookie = name + '=' + encodeURIComponent(value) + ';' + expires + ';path=/;SameSite=Lax';
    }

    // Get a cookie value by name
    function getCookie(name) {
        const nameEQ = name + '=';
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return decodeURIComponent(cookie.substring(nameEQ.length));
            }
        }
        return null;
    }

    // Extract UTM parameters from current URL
    function getUrlParams() {
        const params = {};
        const urlParams = new URLSearchParams(window.location.search);
        
        CONFIG.utmParams.forEach(function(param) {
            const value = urlParams.get(param);
            if (value) {
                params[param] = value;
            }
        });
        
        return params;
    }

    // Save UTM parameters to cookies
    function saveUtmToCookies(params) {
        if (Object.keys(params).length > 0) {
            CONFIG.utmParams.forEach(function(param) {
                if (params[param]) {
                    setCookie(param, params[param], CONFIG.cookieExpireDays);
                }
            });
        }
    }

    // Retrieve UTM parameters from cookies
    function getUtmFromCookies() {
        const params = {};
        
        CONFIG.utmParams.forEach(function(param) {
            const value = getCookie(param);
            if (value) {
                params[param] = value;
            }
        });
        
        return params;
    }

    // Get UTM values from URL or cookies
    function getUtmValues() {
        let params = getUrlParams();
        
        if (Object.keys(params).length > 0) {
            saveUtmToCookies(params);
        } else {
            params = getUtmFromCookies();
        }
        
        return params;
    }

    // Generate regex pattern for all phone number format variations
    function formatPhoneVariations(phone) {
        const digits = phone.replace(/\D/g, '');
        return [
            phone,
            digits,
            '(' + digits.substr(0,3) + ') ' + digits.substr(3,3) + '-' + digits.substr(6),
            digits.substr(0,3) + '.' + digits.substr(3,3) + '.' + digits.substr(6),
            digits.substr(0,3) + ' ' + digits.substr(3,3) + ' ' + digits.substr(6),
            '1-' + phone,
            '+1-' + phone,
            '+1' + digits,
            '1' + digits
        ];
    }

    // Replace default phone numbers with tracking number when utm_source exists
    function swapPhoneNumbers() {
        const utmValues = getUtmValues();
        
        if (!utmValues.utm_source) {
            return;
        }

        const phoneVariations = formatPhoneVariations(CONFIG.defaultPhone);
        const newPhone = CONFIG.trackingPhone;

        const pattern = new RegExp(
            phoneVariations.map(function(p) {
                return p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }).join('|'),
            'g'
        );

        const walker = document.createTreeWalker(
            document.body,
            NodeFilter.SHOW_TEXT,
            null,
            false
        );

        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
            if (pattern.test(node.nodeValue)) {
                textNodes.push(node);
            }
        }

        textNodes.forEach(function(textNode) {
            textNode.nodeValue = textNode.nodeValue.replace(pattern, newPhone);
        });

        const telLinks = document.querySelectorAll('a[href^="tel:"]');
        telLinks.forEach(function(link) {
            const href = link.getAttribute('href');
            const hrefDigits = href.replace(/\D/g, '');
            const defaultDigits = CONFIG.defaultPhone.replace(/\D/g, '');
            
            if (hrefDigits === defaultDigits || hrefDigits === '1' + defaultDigits) {
                link.setAttribute('href', 'tel:' + newPhone);
            }
        });
    }

    // Fill Gravity Forms hidden fields with UTM values
    function populateGravityForms() {
        const utmValues = getUtmValues();
        
        if (Object.keys(utmValues).length === 0) {
            return;
        }

        // Iterate through each form mapping
        Object.keys(CONFIG.gravityFormsMapping).forEach(function(formId) {
            const fieldMapping = CONFIG.gravityFormsMapping[formId];
            
            // Check if this form exists on the page
            const formExists = document.querySelector('#gform_' + formId) || 
                              document.querySelector('#gform_wrapper_' + formId);
            
            if (!formExists) {
                return;
            }

            // Populate each UTM field for this form
            Object.keys(fieldMapping).forEach(function(utmParam) {
                const fieldId = fieldMapping[utmParam];
                const utmValue = utmValues[utmParam];
                
                if (utmValue) {
                    // Gravity Forms uses input_{formId}_{fieldId} naming
                    const fieldSelector = '#input_' + formId + '_' + fieldId;
                    const field = document.querySelector(fieldSelector);
                    
                    if (field) {
                        field.value = utmValue;
                        // Optional: Log for debugging
                        console.log('UTM Tracker: Populated', fieldSelector, '=', utmValue);
                    }
                }
            });
        });
    }

    // Watch for dynamically loaded Gravity Forms
    function observeForForms() {
        populateGravityForms();

        if (typeof MutationObserver !== 'undefined') {
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.addedNodes.length) {
                        mutation.addedNodes.forEach(function(node) {
                            if (node.nodeType === 1) {
                                if (node.classList && (
                                    node.classList.contains('gform_wrapper') ||
                                    node.querySelector && node.querySelector('.gform_wrapper')
                                )) {
                                    setTimeout(populateGravityForms, 100);
                                }
                            }
                        });
                    }
                });
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        if (typeof jQuery !== 'undefined') {
            jQuery(document).on('gform_post_render', function() {
                populateGravityForms();
            });
        }
    }

    // Initialize tracking
    function init() {
        swapPhoneNumbers();
        observeForForms();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.UTMTracker = {
        getUtmValues: getUtmValues,
        populateGravityForms: populateGravityForms,
        swapPhoneNumbers: swapPhoneNumbers,
        config: CONFIG
    };

})();